import colors from "../styles/palette-colors.module.scss"

/**
 * List des variantes de statut disponnibles pour le composant StatusPill
 * Chaque statut a une correspondances à une couleur et une icône qui ne sont pas modifiables
 */
export const StatusPillVariants = {
    A_TRAITER: "A_TRAITER",
    CLOTURE: "CLOTURE",
    EN_COURS: "EN_COURS",
    REFUSE: "REFUSE",
    CONFIRME: "CONFIRME",
}

/**
 * Liste de labels par défaut si on ne passe pas un label personnalisé au composant
 */
export const StatusPillVariantsDefaultLabels = {
    A_TRAITER: "À traiter",
    CLOTURE: "Cloturé",
    EN_COURS: "En cours",
    REFUSE: "Refusé",
    CONFIRME: "Confirmé",
}

export const STATUS_PILL_BACKGROUND_COLORS = {
    [StatusPillVariants.A_TRAITER]: colors.lightBlue200,
    [StatusPillVariants.CLOTURE]: colors.neutral200,
    [StatusPillVariants.EN_COURS]: colors.lightBlue200,
    [StatusPillVariants.REFUSE]: colors.error50,
    [StatusPillVariants.CONFIRME]: colors.success50,
}

export const STATUS_PILL_COLORS = {
    [StatusPillVariants.A_TRAITER]: colors.darkBlue800,
    [StatusPillVariants.CLOTURE]: colors.neutral800,
    [StatusPillVariants.EN_COURS]: colors.darkBlue800,
    [StatusPillVariants.REFUSE]: colors.error700,
    [StatusPillVariants.CONFIRME]: colors.success800,
}

export const STATUS_PILL_ICONS = {
    [StatusPillVariants.A_TRAITER]: "fa-solid fa-circle-ellipsis",
    [StatusPillVariants.CLOTURE]: "fa-solid fa-circle-xmark",
    [StatusPillVariants.EN_COURS]: "fa-solid fa-circle-ellipsis",
    [StatusPillVariants.REFUSE]: "fa-solid fa-circle-xmark",
    [StatusPillVariants.CONFIRME]: "fa-solid fa-circle-check",
}
